import React from 'react'
import {
  amtNumStr,
  amtStr,
} from '@ifca-root/react-component/src/helpers/StringNumberFunction/numFormatter'
import { formatDate } from 'helpers/StringNumberFunction/FormatDate'

interface DetailProps {
  listEl: any
  userList: any
  documentListing?: any
  mode?: string
  listStatus?: string
}

export const ProvisionImpairmentReversalDetailContent = (
  props: DetailProps
) => {
  const { listEl, documentListing, userList, mode } = props

  return (
    <>
      <div className="content-wrap left">
        <div className="desc" style={{ color: 'grey' }}>
          {'Start Date'}
        </div>
        <div className="mdDesc text-noflow">
          {formatDate(listEl?.Asset?.start_use_date)}
        </div>
      </div>
      <div className="content-wrap right">
        <div className="desc" style={{ color: 'grey' }}>
          {'Model No.'}
        </div>
        <div className="mdDesc text-noflow">{listEl?.Asset?.model_no}</div>
      </div>
      <div className="content-wrap left">
        <div className="desc" style={{ color: 'grey' }}>
          {'Original Amount'}
        </div>
        <div className="mdDesc text-noflow">
          {amtStr(listEl?.Asset?.base_original_amount)}
        </div>
      </div>
      <div className="content-wrap right">
        <div className="desc" style={{ color: 'grey' }}>
          {'Quantity'}
        </div>
        <div className="mdDesc text-noflow">{listEl?.Asset?.quantity}</div>
      </div>
      <div className="content-wrap left">
        <div className="desc" style={{ color: 'grey' }}>
          {'Acc. Depreciated Amount'}
        </div>
        <div className="mdDesc text-noflow">
          {amtStr(listEl?.accumulated_depreciated_amount)}
        </div>
      </div>
      <div className="content-wrap right">
        <div className="desc" style={{ color: 'grey' }}>
          {'Residual Value'}
        </div>
        <div className="mdDesc text-noflow">
          {amtStr(listEl?.residual_value)}
        </div>
      </div>
      <div className="content-wrap full">
        <div className="desc" style={{ color: 'grey' }}>
          {'Accumulated Impairment'}
        </div>
        <div className="mdDesc text-noflow">
          {amtStr(listEl?.accumulated_impairment)}
        </div>
      </div>
      <div className="content-wrap left">
        <div className="desc" style={{ color: 'grey' }}>
          {'Submitted Date'}
        </div>
        <div className="mdDesc text-noflow">
          {formatDate(listEl?.submittedTs)}
        </div>
      </div>
      <div className="content-wrap right">
        <div className="desc" style={{ color: 'grey' }}>
          {'Submitted By'}
        </div>
        <div className="mdDesc text-noflow">
          {userList?.filter(user => user.ID == listEl?.submittedBy)[0]?.name ||
            'N/A'}
        </div>
      </div>

      {mode === 'COMPLETED' && (
        <>
          <div className="content-wrap left">
            <div className="desc" style={{ color: 'grey' }}>
              {'Approved Date'}
            </div>
            <div className="mdDesc text-noflow" style={{ fontSize: '11px' }}>
              {formatDate(listEl?.approvedTs)}
            </div>
          </div>
          <div className="content-wrap right">
            <div className="desc" style={{ color: 'grey' }}>
              {'Approved By'}
            </div>
            <div className="mdDesc text-noflow" style={{ fontSize: '11px' }}>
              {userList?.filter(user => user.ID == listEl?.approvedBy)[0]
                ?.name || 'N/A'}
            </div>
          </div>
        </>
      )}

      {mode === 'REJECTED' && (
        <>
          <div className="content-wrap left">
            <div className="desc" style={{ color: 'grey' }}>
              {'Rejection Date'}
            </div>
            <div className="mdDesc text-noflow" style={{ fontSize: '11px' }}>
              {formatDate(listEl?.RejectionDate)}
            </div>
          </div>
          <div className="content-wrap right">
            <div className="desc" style={{ color: 'grey' }}>
              {'Rejection Remark'}
            </div>
            <div className="mdDesc text-noflow" style={{ fontSize: '11px' }}>
              {listEl?.RejectionRemark || 'N/A'}
            </div>
          </div>
        </>
      )}
    </>
  )
}
